<template>
  <div class="md:py-24 text-center" data-testid="error">
    <h1
      class="mt-1 font-extrabold text-gray-900 text-2xl sm:text-3xl sm:tracking-tight"
    >
      {{ texts.error.title }}
    </h1>
    <p class="max-w-xl mt-5 mx-auto text-l text-gray-500">
      {{ texts.error.description }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import { useStore } from "vuex";
import { RootState } from "@/store";
import dictionary from "@/dictionary";
import { Culture } from "@/enums";

export default defineComponent({
  name: "Error",
  setup() {
    const store = useStore<RootState>();
    const texts = dictionary[store.getters["cultureStore/active"] as Culture];

    return { texts };
  },
});
</script>
